/* eslint-disable */
import $ from 'jquery';

(function($, window, document, undefined){
  var defaults = {};

  var Collapsable = function(element, options){
    this._el = element;
    this.$el = $(this._el);
    this.$el.addClass('collapsable--enabled');
    this.$elContent = this.$el.find('.collapsable__content');
    this.$elTrigger = this.$el.children('.btn');
    this.state = 'opened';

    this._options = options;
    this.options = $.extend({}, defaults, this._options);
    this.options = $.extend({}, this.options, this.$el.data());

    this.init();
  };

  $.extend(Collapsable.prototype, {
    init: function(){
      this.bindEvents();
    },
    bindEvents: function(){
      this.$elTrigger.on('click.Collapsable', $.proxy(this.toggleContent, this));
    },
    toggleContent: function(event){
      event.preventDefault();
      this.$el.toggleClass('is--collapsed');
      if (this.state === 'opened') {
        this.$elContent.slideUp();
        this.$elTrigger.find('.btn__text').text(this.options.buttonTextOpen);
        this.state = 'closed';

        $('html, body').animate({
          'scrollTop': this.$el.offset().top - $('.page-header').height() - 20
        }, 500);
      } else if (this.state === 'closed') {
        this.$elContent.slideDown();
        this.$elTrigger.find('.btn__text').text(this.options.buttonTextClose);
        this.state = 'opened';
      }
    }
  });

  $.fn.Collapsable = function(options){
    return this.each(function(){
      var returnValue = null;
      if (!$.data(this, 'Collapsable')) {
        returnValue = $.data(this, 'Collapsable', new Collapsable(this, options));
      } else {
        returnValue = $.data(this, 'Collapsable');
      }
      return returnValue;
    });
  };

  $('.collapsable').Collapsable();
})($, window, document);



// WEBPACK FOOTER //
// ./assets/js/components/collapsable.js